import simpleParallax from 'simple-parallax-js';

const images = document.querySelectorAll( '.eb-js-hero-visual-image' );

new simpleParallax( images, {
	scale: 1.75,
	orientation: 'down',
} );
